import { defaultAlt } from '@/components/Image';
import { LinearProgressBar } from '@/components/LinearProgressBar';
import cx from 'classnames';
import type { WithChildren } from 'types/withChildren';

import Grid from '@material-ui/core/Grid';

import css from './style.module.scss';

export type ContainerProps = WithChildren<{
  divide?: boolean;
  leftContent?: React.ReactNode;
  img?: string;
  imgAlt?: string;
  fullContent?: boolean;
  progress?: number;
  blueBackground?: boolean;
}>;

export const ProgressBarLayout = ({
  children,
  divide,
  img,
  imgAlt,
  leftContent,
  progress,
  blueBackground,
}: ContainerProps) => {
  if (divide) {
    return (
      <div className={cx(css.mainContainer, blueBackground && css['blueBackground'])}>
        {progress && (
          <div className={css.progressBar}>
            <LinearProgressBar value={progress} />
          </div>
        )}

        <Grid container justifyContent="center">
          <Grid item lg={5} xs={12} md>
            <aside>{leftContent || <img src={img || ''} alt={imgAlt || defaultAlt} />}</aside>
          </Grid>

          <Grid item lg={7} xs={12} md>
            <main className={css.rightContent}>{children}</main>
          </Grid>
        </Grid>
      </div>
    );
  }
  return <div className={css.mainContainer}>{children}</div>;
};
